import GuicheForm from "./form";
import { AttendanceLocalGuiche } from "../../../../../../../@types/attendance-local-guiche";
import { useAttendanceLocalGuicheUpdate } from "../../../../../../../services/api-tansquery/attendance-local/guiche/update";

type GuicheFormProps = {
    slug: string;
    guiche: AttendanceLocalGuiche;
    buttonTrigger?: React.ReactNode;
};

export default function GuicheFormUpdate(props: GuicheFormProps) {
    const mutation = useAttendanceLocalGuicheUpdate(props.guiche.id);

    return (
        <GuicheForm
            {...props}
            mutation={mutation}
        />
    );
}
